/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from '@angular/core';
import * as i1 from '@progress/kendo-angular-dialog';
import * as i2 from '@angular/common';
import * as i3 from '@progress/kendo-angular-l10n';
export const DialogModuleNgFactory:i0.NgModuleFactory<i1.DialogModule> = i0.ɵcmf(i1.DialogModule,
    ([] as any[]),(_l:any) => {
      return i0.ɵmod([i0.ɵmpd(512,i0.ComponentFactoryResolver,i0.ɵCodegenComponentFactoryResolver,
          [[8,[DialogComponentNgFactory,DialogTitleBarComponentNgFactory]],[3,i0.ComponentFactoryResolver],
              i0.NgModuleRef]),i0.ɵmpd(4608,i2.NgLocalization,i2.NgLocaleLocalization,
          [i0.LOCALE_ID]),i0.ɵmpd(4608,i1.DialogContainerService,i1.DialogContainerService,
          ([] as any[])),i0.ɵmpd(4608,i1.DialogService,i1.DialogService,[i0.ComponentFactoryResolver,
          i1.DialogContainerService]),i0.ɵmpd(512,i2.CommonModule,i2.CommonModule,
          ([] as any[])),i0.ɵmpd(512,i1.SharedModule,i1.SharedModule,([] as any[])),
          i0.ɵmpd(512,i1.DialogModule,i1.DialogModule,([] as any[]))]);
    });
export const SharedModuleNgFactory:i0.NgModuleFactory<i1.SharedModule> = i0.ɵcmf(i1.SharedModule,
    ([] as any[]),(_l:any) => {
      return i0.ɵmod([i0.ɵmpd(512,i0.ComponentFactoryResolver,i0.ɵCodegenComponentFactoryResolver,
          [[8,([] as any[])],[3,i0.ComponentFactoryResolver],i0.NgModuleRef]),i0.ɵmpd(4608,
          i2.NgLocalization,i2.NgLocaleLocalization,[i0.LOCALE_ID]),i0.ɵmpd(512,i2.CommonModule,
          i2.CommonModule,([] as any[])),i0.ɵmpd(512,i1.SharedModule,i1.SharedModule,
          ([] as any[]))]);
    });
export const WindowModuleNgFactory:i0.NgModuleFactory<i1.WindowModule> = i0.ɵcmf(i1.WindowModule,
    ([] as any[]),(_l:any) => {
      return i0.ɵmod([i0.ɵmpd(512,i0.ComponentFactoryResolver,i0.ɵCodegenComponentFactoryResolver,
          [[8,[WindowComponentNgFactory,WindowTitleBarComponentNgFactory]],[3,i0.ComponentFactoryResolver],
              i0.NgModuleRef]),i0.ɵmpd(4608,i2.NgLocalization,i2.NgLocaleLocalization,
          [i0.LOCALE_ID]),i0.ɵmpd(4608,i1.WindowContainerService,i1.WindowContainerService,
          ([] as any[])),i0.ɵmpd(4608,i1.WindowService,i1.WindowService,[i0.ComponentFactoryResolver,
          i1.WindowContainerService]),i0.ɵmpd(512,i2.CommonModule,i2.CommonModule,
          ([] as any[])),i0.ɵmpd(512,i1.SharedModule,i1.SharedModule,([] as any[])),
          i0.ɵmpd(512,i1.WindowModule,i1.WindowModule,([] as any[]))]);
    });
export const DialogsModuleNgFactory:i0.NgModuleFactory<i1.DialogsModule> = i0.ɵcmf(i1.DialogsModule,
    ([] as any[]),(_l:any) => {
      return i0.ɵmod([i0.ɵmpd(512,i0.ComponentFactoryResolver,i0.ɵCodegenComponentFactoryResolver,
          [[8,[DialogComponentNgFactory,DialogTitleBarComponentNgFactory,WindowComponentNgFactory,
              WindowTitleBarComponentNgFactory]],[3,i0.ComponentFactoryResolver],i0.NgModuleRef]),
          i0.ɵmpd(4608,i2.NgLocalization,i2.NgLocaleLocalization,[i0.LOCALE_ID]),i0.ɵmpd(4608,
              i1.DialogContainerService,i1.DialogContainerService,([] as any[])),i0.ɵmpd(4608,
              i1.DialogService,i1.DialogService,[i0.ComponentFactoryResolver,i1.DialogContainerService]),
          i0.ɵmpd(4608,i1.WindowContainerService,i1.WindowContainerService,([] as any[])),
          i0.ɵmpd(4608,i1.WindowService,i1.WindowService,[i0.ComponentFactoryResolver,
              i1.WindowContainerService]),i0.ɵmpd(512,i2.CommonModule,i2.CommonModule,
              ([] as any[])),i0.ɵmpd(512,i1.SharedModule,i1.SharedModule,([] as any[])),
          i0.ɵmpd(512,i1.DialogModule,i1.DialogModule,([] as any[])),i0.ɵmpd(512,i1.WindowModule,
              i1.WindowModule,([] as any[])),i0.ɵmpd(512,i1.DialogsModule,i1.DialogsModule,
              ([] as any[]))]);
    });
const styles_DialogComponent:any[] = ([] as any[]);
export const RenderType_DialogComponent:i0.RendererType2 = i0.ɵcrt({encapsulation:2,
    styles:styles_DialogComponent,data:{'animation':[{type:7,name:'overlayAppear',
        definitions:[{type:0,name:'in',styles:{type:6,styles:{opacity:1},offset:(null as any)},
            options:(undefined as any)},{type:1,expr:'void => *',animation:[{type:6,
            styles:{opacity:0.1},offset:(null as any)},{type:4,styles:(null as any),
            timings:'.3s cubic-bezier(.2, .6, .4, 1)'}],options:(null as any)}],options:{}},
        {type:7,name:'dialogSlideInAppear',definitions:[{type:0,name:'in',styles:{type:6,
            styles:{transform:'translate(0, 0)'},offset:(null as any)},options:(undefined as any)},
            {type:1,expr:'void => *',animation:[{type:6,styles:{transform:'translate(0, -10%)'},
                offset:(null as any)},{type:4,styles:(null as any),timings:'.3s cubic-bezier(.2, 1, .2, 1)'}],
                options:(null as any)}],options:{}}]}});
function View_DialogComponent_1(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,(null as any),(null as any),2,'kendo-dialog-titlebar',
      ([] as any[]),[[8,'id',0],[2,'k-window-titlebar',(null as any)],[2,'k-dialog-titlebar',
          (null as any)],[2,'k-header',(null as any)]],(null as any),(null as any),
      View_DialogTitleBarComponent_0,RenderType_DialogTitleBarComponent)),i0.ɵdid(49152,
      [[1,4]],0,i1.DialogTitleBarComponent,([] as any[]),{id:[0,'id']},(null as any)),
      (_l()(),i0.ɵted(0,['','']))],(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_4:any = _co.titleId;
    _ck(_v,1,0,currVal_4);
  },(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_0:any = i0.ɵnov(_v,1).id;
    const currVal_1:any = i0.ɵnov(_v,1).className;
    const currVal_2:any = i0.ɵnov(_v,1).className;
    const currVal_3:any = i0.ɵnov(_v,1).className;
    _ck(_v,0,0,currVal_0,currVal_1,currVal_2,currVal_3);
    const currVal_5:any = _co.title;
    _ck(_v,2,0,currVal_5);
  });
}
function View_DialogComponent_2(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[i0.ɵncd((null as any),0),(_l()(),i0.ɵand(0,(null as any),(null as any),
      0))],(null as any),(null as any));
}
function View_DialogComponent_3(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[i0.ɵncd((null as any),1),(_l()(),i0.ɵand(0,(null as any),(null as any),
      0))],(null as any),(null as any));
}
function View_DialogComponent_5(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵand(0,(null as any),(null as any),0))],(null as any),
      (null as any));
}
function View_DialogComponent_4(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵand(16777216,(null as any),(null as any),1,(null as any),
      View_DialogComponent_5)),i0.ɵdid(540672,(null as any),0,i2.NgTemplateOutlet,
      [i0.ViewContainerRef],{ngTemplateOutlet:[0,'ngTemplateOutlet']},(null as any)),
      (_l()(),i0.ɵand(0,(null as any),(null as any),0))],(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_0:any = _co.contentTemplate;
    _ck(_v,1,0,currVal_0);
  },(null as any));
}
function View_DialogComponent_6(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[i0.ɵncd((null as any),2),(_l()(),i0.ɵand(0,(null as any),(null as any),
      0))],(null as any),(null as any));
}
function View_DialogComponent_7(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,(null as any),(null as any),1,'kendo-dialog-actions',
      ([] as any[]),[[2,'k-dialog-buttongroup',(null as any)],[2,'k-dialog-button-layout-stretched',
          (null as any)]],(null as any),(null as any),View_DialogActionsComponent_0,
      RenderType_DialogActionsComponent)),i0.ɵdid(49152,[[2,4]],0,i1.DialogActionsComponent,
      [i0.ElementRef],{actions:[0,'actions']},(null as any))],(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_2:any = _co.actions;
    _ck(_v,1,0,currVal_2);
  },(_ck,_v) => {
    const currVal_0:any = i0.ɵnov(_v,1).className;
    const currVal_1:any = i0.ɵnov(_v,1).className;
    _ck(_v,0,0,currVal_0,currVal_1);
  });
}
export function View_DialogComponent_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[i0.ɵqud(671088640,1,{titlebarView:0}),i0.ɵqud(671088640,2,{actionsView:0}),
      (_l()(),i0.ɵted((null as any),['\n    '])),(_l()(),i0.ɵeld(0,(null as any),(null as any),
          0,'div',[['class','k-overlay']],[[24,'@overlayAppear',0]],(null as any),
          (null as any),(null as any),(null as any))),(_l()(),i0.ɵted((null as any),
          ['\n\n    '])),(_l()(),i0.ɵeld(0,(null as any),(null as any),23,'div',[['class',
          'k-widget k-window k-dialog'],['role','dialog']],[[24,'@dialogSlideInAppear',
          0]],(null as any),(null as any),(null as any),(null as any))),i0.ɵdid(278528,
          (null as any),0,i2.NgStyle,[i0.KeyValueDiffers,i0.ElementRef,i0.Renderer],
          {ngStyle:[0,'ngStyle']},(null as any)),(_l()(),i0.ɵted((null as any),['\n      '])),
      (_l()(),i0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_DialogComponent_1)),
      i0.ɵdid(16384,(null as any),0,i2.NgIf,[i0.ViewContainerRef,i0.TemplateRef],{ngIf:[0,
          'ngIf']},(null as any)),(_l()(),i0.ɵted((null as any),['\n      '])),(_l()(),
          i0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_DialogComponent_2)),
      i0.ɵdid(16384,(null as any),0,i2.NgIf,[i0.ViewContainerRef,i0.TemplateRef],{ngIf:[0,
          'ngIf']},(null as any)),(_l()(),i0.ɵted((null as any),['\n\n      '])),(_l()(),
          i0.ɵeld(0,(null as any),(null as any),7,'div',[['class','k-content k-window-content k-dialog-content']],
              (null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i0.ɵted((null as any),['\n        '])),(_l()(),i0.ɵand(16777216,(null as any),
          (null as any),1,(null as any),View_DialogComponent_3)),i0.ɵdid(16384,(null as any),
          0,i2.NgIf,[i0.ViewContainerRef,i0.TemplateRef],{ngIf:[0,'ngIf']},(null as any)),
      (_l()(),i0.ɵted((null as any),['\n        '])),(_l()(),i0.ɵand(16777216,(null as any),
          (null as any),1,(null as any),View_DialogComponent_4)),i0.ɵdid(16384,(null as any),
          0,i2.NgIf,[i0.ViewContainerRef,i0.TemplateRef],{ngIf:[0,'ngIf']},(null as any)),
      (_l()(),i0.ɵted((null as any),['\n      '])),(_l()(),i0.ɵted((null as any),['\n\n      '])),
      (_l()(),i0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_DialogComponent_6)),
      i0.ɵdid(16384,(null as any),0,i2.NgIf,[i0.ViewContainerRef,i0.TemplateRef],{ngIf:[0,
          'ngIf']},(null as any)),(_l()(),i0.ɵted((null as any),['\n      '])),(_l()(),
          i0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_DialogComponent_7)),
      i0.ɵdid(16384,(null as any),0,i2.NgIf,[i0.ViewContainerRef,i0.TemplateRef],{ngIf:[0,
          'ngIf']},(null as any)),(_l()(),i0.ɵted((null as any),['\n\n    '])),(_l()(),
          i0.ɵted((null as any),['\n  ']))],(_ck,_v) => {
    var _co:i1.DialogComponent = _v.component;
    const currVal_2:any = _co.styles;
    _ck(_v,6,0,currVal_2);
    const currVal_3:any = _co.title;
    _ck(_v,9,0,currVal_3);
    const currVal_4:boolean = !_co.title;
    _ck(_v,12,0,currVal_4);
    const currVal_5:boolean = !_co.contentTemplate;
    _ck(_v,17,0,currVal_5);
    const currVal_6:any = _co.contentTemplate;
    _ck(_v,20,0,currVal_6);
    const currVal_7:boolean = !_co.actions;
    _ck(_v,24,0,currVal_7);
    const currVal_8:any = _co.actions;
    _ck(_v,27,0,currVal_8);
  },(_ck,_v) => {
    const currVal_0:any = (undefined as any);
    _ck(_v,3,0,currVal_0);
    const currVal_1:any = (undefined as any);
    _ck(_v,5,0,currVal_1);
  });
}
export function View_DialogComponent_Host_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,(null as any),(null as any),4,'kendo-dialog',
      ([] as any[]),[[1,'dir',0],[1,'tabIndex',0],[2,'k-dialog-wrapper',(null as any)]],
      [[(null as any),'keydown']],(_v,en,$event) => {
        var ad:boolean = true;
        if (('keydown' === en)) {
          const pd_0:any = ((<any>i0.ɵnov(_v,3).onComponentKeydown($event)) !== false);
          ad = (pd_0 && ad);
        }
        return ad;
      },View_DialogComponent_0,RenderType_DialogComponent)),i0.ɵprd(256,(null as any),
      i3.L10N_PREFIX,'kendo.dialog',([] as any[])),i0.ɵprd(131584,(null as any),i3.LocalizationService,
      i3.LocalizationService,[i3.L10N_PREFIX,[2,i3.MessageService],[2,i3.RTL]]),i0.ɵdid(5488640,
      (null as any),1,i1.DialogComponent,[i0.ElementRef,i0.Renderer2,i3.LocalizationService],
      (null as any),(null as any)),i0.ɵqud(335544320,1,{titlebarContent:0})],(_ck,
      _v) => {
    _ck(_v,3,0);
  },(_ck,_v) => {
    const currVal_0:any = i0.ɵnov(_v,3).dir;
    const currVal_1:any = i0.ɵnov(_v,3).tabIndex;
    const currVal_2:any = i0.ɵnov(_v,3).wrapperClass;
    _ck(_v,0,0,currVal_0,currVal_1,currVal_2);
  });
}
export const DialogComponentNgFactory:i0.ComponentFactory<i1.DialogComponent> = i0.ɵccf('kendo-dialog',
    i1.DialogComponent,View_DialogComponent_Host_0,{title:'title',actions:'actions',
        width:'width',minWidth:'minWidth',height:'height'},{action:'action',close:'close'},
    ['kendo-dialog-titlebar','*','kendo-dialog-actions']);
const styles_DialogTitleBarComponent:any[] = ([] as any[]);
export const RenderType_DialogTitleBarComponent:i0.RendererType2 = i0.ɵcrt({encapsulation:2,
    styles:styles_DialogTitleBarComponent,data:{}});
export function View_DialogTitleBarComponent_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵted((null as any),['\n    '])),(_l()(),i0.ɵeld(0,(null as any),
      (null as any),3,'div',[['class','k-window-title k-dialog-title']],(null as any),
      (null as any),(null as any),(null as any),(null as any))),(_l()(),i0.ɵted((null as any),
      ['\n      '])),i0.ɵncd((null as any),0),(_l()(),i0.ɵted((null as any),['\n    '])),
      (_l()(),i0.ɵted((null as any),['\n    '])),(_l()(),i0.ɵeld(0,(null as any),(null as any),
          6,'div',[['class','k-window-actions k-dialog-actions']],(null as any),(null as any),
          (null as any),(null as any),(null as any))),(_l()(),i0.ɵted((null as any),
          ['\n      '])),(_l()(),i0.ɵeld(0,(null as any),(null as any),3,'a',[['aria-label',
          'Close'],['class','k-button k-bare k-button-icon k-window-action k-dialog-action k-dialog-close'],
          ['href','#'],['role','button']],(null as any),[[(null as any),'click']],
          (_v,en,$event) => {
            var ad:boolean = true;
            var _co:i1.DialogTitleBarComponent = _v.component;
            if (('click' === en)) {
              const pd_0:any = ((<any>_co.onCloseClick($event)) !== false);
              ad = (pd_0 && ad);
            }
            return ad;
          },(null as any),(null as any))),(_l()(),i0.ɵted((null as any),['\n        '])),
      (_l()(),i0.ɵeld(0,(null as any),(null as any),0,'span',[['class','k-icon k-i-x']],
          (null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i0.ɵted((null as any),['\n      '])),(_l()(),i0.ɵted((null as any),['\n    '])),
      (_l()(),i0.ɵted((null as any),['\n  ']))],(null as any),(null as any));
}
export function View_DialogTitleBarComponent_Host_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,(null as any),(null as any),1,'kendo-dialog-titlebar',
      ([] as any[]),[[8,'id',0],[2,'k-window-titlebar',(null as any)],[2,'k-dialog-titlebar',
          (null as any)],[2,'k-header',(null as any)]],(null as any),(null as any),
      View_DialogTitleBarComponent_0,RenderType_DialogTitleBarComponent)),i0.ɵdid(49152,
      (null as any),0,i1.DialogTitleBarComponent,([] as any[]),(null as any),(null as any))],
      (null as any),(_ck,_v) => {
        const currVal_0:any = i0.ɵnov(_v,1).id;
        const currVal_1:any = i0.ɵnov(_v,1).className;
        const currVal_2:any = i0.ɵnov(_v,1).className;
        const currVal_3:any = i0.ɵnov(_v,1).className;
        _ck(_v,0,0,currVal_0,currVal_1,currVal_2,currVal_3);
      });
}
export const DialogTitleBarComponentNgFactory:i0.ComponentFactory<i1.DialogTitleBarComponent> = i0.ɵccf('kendo-dialog-titlebar',
    i1.DialogTitleBarComponent,View_DialogTitleBarComponent_Host_0,{id:'id'},{close:'close'},
    ['*']);
const styles_DialogActionsComponent:any[] = ([] as any[]);
export const RenderType_DialogActionsComponent:i0.RendererType2 = i0.ɵcrt({encapsulation:2,
    styles:styles_DialogActionsComponent,data:{}});
function View_DialogActionsComponent_1(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[i0.ɵncd((null as any),0),(_l()(),i0.ɵand(0,(null as any),(null as any),
      0))],(null as any),(null as any));
}
function View_DialogActionsComponent_3(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,(null as any),(null as any),2,'button',([] as any[]),
      (null as any),[[(null as any),'click']],(_v,en,$event) => {
        var ad:boolean = true;
        var _co:any = _v.component;
        if (('click' === en)) {
          const pd_0:any = ((<any>_co.onButtonClick(_v.context.$implicit,$event)) !== false);
          ad = (pd_0 && ad);
        }
        return ad;
      },(null as any),(null as any))),i0.ɵdid(278528,(null as any),0,i2.NgClass,[i0.IterableDiffers,
      i0.KeyValueDiffers,i0.ElementRef,i0.Renderer],{ngClass:[0,'ngClass']},(null as any)),
      (_l()(),i0.ɵted((null as any),['\n        ','\n      ']))],(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_0:any = _co.buttonClass(_v.context.$implicit);
    _ck(_v,1,0,currVal_0);
  },(_ck,_v) => {
    const currVal_1:any = _v.context.$implicit.text;
    _ck(_v,2,0,currVal_1);
  });
}
function View_DialogActionsComponent_2(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,(null as any),(null as any),4,(null as any),
      (null as any),(null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i0.ɵted((null as any),['\n      '])),(_l()(),i0.ɵand(16777216,(null as any),
          (null as any),1,(null as any),View_DialogActionsComponent_3)),i0.ɵdid(802816,
          (null as any),0,i2.NgForOf,[i0.ViewContainerRef,i0.TemplateRef,i0.IterableDiffers],
          {ngForOf:[0,'ngForOf']},(null as any)),(_l()(),i0.ɵted((null as any),['\n    ']))],
      (_ck,_v) => {
        var _co:any = _v.component;
        const currVal_0:any = _co.actions;
        _ck(_v,3,0,currVal_0);
      },(null as any));
}
function View_DialogActionsComponent_5(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵand(0,(null as any),(null as any),0))],(null as any),
      (null as any));
}
function View_DialogActionsComponent_4(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵand(16777216,(null as any),(null as any),1,(null as any),
      View_DialogActionsComponent_5)),i0.ɵdid(540672,(null as any),0,i2.NgTemplateOutlet,
      [i0.ViewContainerRef],{ngTemplateOutlet:[0,'ngTemplateOutlet']},(null as any)),
      (_l()(),i0.ɵand(0,(null as any),(null as any),0))],(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_0:any = _co.actions;
    _ck(_v,1,0,currVal_0);
  },(null as any));
}
export function View_DialogActionsComponent_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵted((null as any),['\n    '])),(_l()(),i0.ɵand(16777216,
      (null as any),(null as any),1,(null as any),View_DialogActionsComponent_1)),
      i0.ɵdid(16384,(null as any),0,i2.NgIf,[i0.ViewContainerRef,i0.TemplateRef],{ngIf:[0,
          'ngIf']},(null as any)),(_l()(),i0.ɵted((null as any),['\n    '])),(_l()(),
          i0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_DialogActionsComponent_2)),
      i0.ɵdid(16384,(null as any),0,i2.NgIf,[i0.ViewContainerRef,i0.TemplateRef],{ngIf:[0,
          'ngIf']},(null as any)),(_l()(),i0.ɵted((null as any),['\n    '])),(_l()(),
          i0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_DialogActionsComponent_4)),
      i0.ɵdid(16384,(null as any),0,i2.NgIf,[i0.ViewContainerRef,i0.TemplateRef],{ngIf:[0,
          'ngIf']},(null as any)),(_l()(),i0.ɵted((null as any),['\n  ']))],(_ck,_v) => {
    var _co:i1.DialogActionsComponent = _v.component;
    const currVal_0:boolean = !_co.actions;
    _ck(_v,2,0,currVal_0);
    const currVal_1:boolean = !_co.actionTemplate();
    _ck(_v,5,0,currVal_1);
    const currVal_2:any = _co.actionTemplate();
    _ck(_v,8,0,currVal_2);
  },(null as any));
}
export function View_DialogActionsComponent_Host_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,(null as any),(null as any),1,'kendo-dialog-actions',
      ([] as any[]),[[2,'k-dialog-buttongroup',(null as any)],[2,'k-dialog-button-layout-stretched',
          (null as any)]],(null as any),(null as any),View_DialogActionsComponent_0,
      RenderType_DialogActionsComponent)),i0.ɵdid(49152,(null as any),0,i1.DialogActionsComponent,
      [i0.ElementRef],(null as any),(null as any))],(null as any),(_ck,_v) => {
    const currVal_0:any = i0.ɵnov(_v,1).className;
    const currVal_1:any = i0.ɵnov(_v,1).className;
    _ck(_v,0,0,currVal_0,currVal_1);
  });
}
export const DialogActionsComponentNgFactory:i0.ComponentFactory<i1.DialogActionsComponent> = i0.ɵccf('kendo-dialog-actions',
    i1.DialogActionsComponent,View_DialogActionsComponent_Host_0,{actions:'actions'},
    {action:'action'},['*']);
const styles_WindowComponent:any[] = ([] as any[]);
export const RenderType_WindowComponent:i0.RendererType2 = i0.ɵcrt({encapsulation:2,
    styles:styles_WindowComponent,data:{}});
function View_WindowComponent_1(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,(null as any),(null as any),25,'kendo-window-titlebar',
      ([] as any[]),[[2,'k-window-titlebar',(null as any)],[2,'k-dialog-titlebar',
          (null as any)],[2,'k-header',(null as any)]],[[(null as any),'dblclick']],
      (_v,en,$event) => {
        var ad:boolean = true;
        if (('dblclick' === en)) {
          const pd_0:any = ((<any>i0.ɵnov(_v,1).handle($event)) !== false);
          ad = (pd_0 && ad);
        }
        return ad;
      },View_WindowTitleBarComponent_0,RenderType_WindowTitleBarComponent)),i0.ɵdid(245760,
      [[1,4]],0,i1.WindowTitleBarComponent,[i0.ElementRef,i1.DragResizeService,i0.NgZone],
      {template:[0,'template']},(null as any)),(_l()(),i0.ɵted(0,['\n            '])),
      (_l()(),i0.ɵeld(0,(null as any),0,1,'div',[['class','k-window-title']],(null as any),
          (null as any),(null as any),(null as any),(null as any))),(_l()(),i0.ɵted((null as any),
          ['',''])),(_l()(),i0.ɵted(0,['\n            '])),(_l()(),i0.ɵeld(0,(null as any),
          0,3,'button',[['kendoWindowMinimizeAction','']],[[2,'k-button',(null as any)],
              [2,'k-state-disabled',(null as any)],[2,'k-primary',(null as any)],[2,
                  'k-bare',(null as any)],[2,'k-state-active',(null as any)],[1,'dir',
                  0],[4,'display',(null as any)]],[[(null as any),'click']],(_v,en,
              $event) => {
            var ad:boolean = true;
            if (('click' === en)) {
              const pd_0:any = ((<any>i0.ɵnov(_v,9).onClick()) !== false);
              ad = (pd_0 && ad);
            }
            return ad;
          },(null as any),(null as any))),i0.ɵprd(256,(null as any),i3.L10N_PREFIX,
          'kendo.button',([] as any[])),i0.ɵprd(131584,(null as any),i3.LocalizationService,
          i3.LocalizationService,[i3.L10N_PREFIX,[2,i3.MessageService],[2,i3.RTL]]),
      i0.ɵdid(8536064,(null as any),0,i1.WindowMinimizeActionDirective,[i0.ElementRef,
          i0.Renderer2,[2,i1.DragResizeService],i3.LocalizationService],(null as any),
          (null as any)),(_l()(),i0.ɵted(0,['\n            '])),(_l()(),i0.ɵeld(0,
          (null as any),0,3,'button',[['kendoWindowMaximizeAction','']],[[2,'k-button',
              (null as any)],[2,'k-state-disabled',(null as any)],[2,'k-primary',(null as any)],
              [2,'k-bare',(null as any)],[2,'k-state-active',(null as any)],[1,'dir',
                  0],[4,'display',(null as any)]],[[(null as any),'click']],(_v,en,
              $event) => {
            var ad:boolean = true;
            if (('click' === en)) {
              const pd_0:any = ((<any>i0.ɵnov(_v,14).onClick()) !== false);
              ad = (pd_0 && ad);
            }
            return ad;
          },(null as any),(null as any))),i0.ɵprd(256,(null as any),i3.L10N_PREFIX,
          'kendo.button',([] as any[])),i0.ɵprd(131584,(null as any),i3.LocalizationService,
          i3.LocalizationService,[i3.L10N_PREFIX,[2,i3.MessageService],[2,i3.RTL]]),
      i0.ɵdid(8536064,(null as any),0,i1.WindowMaximizeActionDirective,[i0.ElementRef,
          i0.Renderer2,[2,i1.DragResizeService],i3.LocalizationService],(null as any),
          (null as any)),(_l()(),i0.ɵted(0,['\n            '])),(_l()(),i0.ɵeld(0,
          (null as any),0,3,'button',[['kendoWindowRestoreAction','']],[[2,'k-button',
              (null as any)],[2,'k-state-disabled',(null as any)],[2,'k-primary',(null as any)],
              [2,'k-bare',(null as any)],[2,'k-state-active',(null as any)],[1,'dir',
                  0],[4,'display',(null as any)]],[[(null as any),'click']],(_v,en,
              $event) => {
            var ad:boolean = true;
            if (('click' === en)) {
              const pd_0:any = ((<any>i0.ɵnov(_v,19).onClick()) !== false);
              ad = (pd_0 && ad);
            }
            return ad;
          },(null as any),(null as any))),i0.ɵprd(256,(null as any),i3.L10N_PREFIX,
          'kendo.button',([] as any[])),i0.ɵprd(131584,(null as any),i3.LocalizationService,
          i3.LocalizationService,[i3.L10N_PREFIX,[2,i3.MessageService],[2,i3.RTL]]),
      i0.ɵdid(8536064,(null as any),0,i1.WindowRestoreActionDirective,[i0.ElementRef,
          i0.Renderer2,[2,i1.DragResizeService],i3.LocalizationService],(null as any),
          (null as any)),(_l()(),i0.ɵted(0,['\n            '])),(_l()(),i0.ɵeld(0,
          (null as any),0,3,'button',[['kendoWindowCloseAction','']],[[2,'k-button',
              (null as any)],[2,'k-state-disabled',(null as any)],[2,'k-primary',(null as any)],
              [2,'k-bare',(null as any)],[2,'k-state-active',(null as any)],[1,'dir',
                  0]],[[(null as any),'click']],(_v,en,$event) => {
            var ad:boolean = true;
            if (('click' === en)) {
              const pd_0:any = ((<any>i0.ɵnov(_v,24).onClick()) !== false);
              ad = (pd_0 && ad);
            }
            return ad;
          },(null as any),(null as any))),i0.ɵprd(256,(null as any),i3.L10N_PREFIX,
          'kendo.button',([] as any[])),i0.ɵprd(131584,(null as any),i3.LocalizationService,
          i3.LocalizationService,[i3.L10N_PREFIX,[2,i3.MessageService],[2,i3.RTL]]),
      i0.ɵdid(8536064,(null as any),0,i1.WindowCloseActionDirective,[i0.ElementRef,
          i0.Renderer2,[2,i1.DragResizeService],i3.LocalizationService],(null as any),
          (null as any)),(_l()(),i0.ɵted(0,['\n        ']))],(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_3:any = _co.titleBarTemplate;
    _ck(_v,1,0,currVal_3);
  },(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_0:any = i0.ɵnov(_v,1).className;
    const currVal_1:any = i0.ɵnov(_v,1).className;
    const currVal_2:any = i0.ɵnov(_v,1).className;
    _ck(_v,0,0,currVal_0,currVal_1,currVal_2);
    const currVal_4:any = _co.title;
    _ck(_v,4,0,currVal_4);
    const currVal_5:any = i0.ɵnov(_v,9).classButton;
    const currVal_6:any = i0.ɵnov(_v,9).classDisabled;
    const currVal_7:any = i0.ɵnov(_v,9).classPrimary;
    const currVal_8:any = i0.ɵnov(_v,9).classBare;
    const currVal_9:any = i0.ɵnov(_v,9).classActive;
    const currVal_10:any = i0.ɵnov(_v,9).dir;
    const currVal_11:any = i0.ɵnov(_v,9).visible;
    _ck(_v,6,0,currVal_5,currVal_6,currVal_7,currVal_8,currVal_9,currVal_10,currVal_11);
    const currVal_12:any = i0.ɵnov(_v,14).classButton;
    const currVal_13:any = i0.ɵnov(_v,14).classDisabled;
    const currVal_14:any = i0.ɵnov(_v,14).classPrimary;
    const currVal_15:any = i0.ɵnov(_v,14).classBare;
    const currVal_16:any = i0.ɵnov(_v,14).classActive;
    const currVal_17:any = i0.ɵnov(_v,14).dir;
    const currVal_18:any = i0.ɵnov(_v,14).visible;
    _ck(_v,11,0,currVal_12,currVal_13,currVal_14,currVal_15,currVal_16,currVal_17,
        currVal_18);
    const currVal_19:any = i0.ɵnov(_v,19).classButton;
    const currVal_20:any = i0.ɵnov(_v,19).classDisabled;
    const currVal_21:any = i0.ɵnov(_v,19).classPrimary;
    const currVal_22:any = i0.ɵnov(_v,19).classBare;
    const currVal_23:any = i0.ɵnov(_v,19).classActive;
    const currVal_24:any = i0.ɵnov(_v,19).dir;
    const currVal_25:any = i0.ɵnov(_v,19).visible;
    _ck(_v,16,0,currVal_19,currVal_20,currVal_21,currVal_22,currVal_23,currVal_24,
        currVal_25);
    const currVal_26:any = i0.ɵnov(_v,24).classButton;
    const currVal_27:any = i0.ɵnov(_v,24).classDisabled;
    const currVal_28:any = i0.ɵnov(_v,24).classPrimary;
    const currVal_29:any = i0.ɵnov(_v,24).classBare;
    const currVal_30:any = i0.ɵnov(_v,24).classActive;
    const currVal_31:any = i0.ɵnov(_v,24).dir;
    _ck(_v,21,0,currVal_26,currVal_27,currVal_28,currVal_29,currVal_30,currVal_31);
  });
}
function View_WindowComponent_2(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[i0.ɵncd((null as any),0),(_l()(),i0.ɵand(0,(null as any),(null as any),
      0))],(null as any),(null as any));
}
function View_WindowComponent_4(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[i0.ɵncd((null as any),1),(_l()(),i0.ɵand(0,(null as any),(null as any),
      0))],(null as any),(null as any));
}
function View_WindowComponent_6(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵand(0,(null as any),(null as any),0))],(null as any),
      (null as any));
}
function View_WindowComponent_5(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵand(16777216,(null as any),(null as any),1,(null as any),
      View_WindowComponent_6)),i0.ɵdid(540672,(null as any),0,i2.NgTemplateOutlet,
      [i0.ViewContainerRef],{ngTemplateOutlet:[0,'ngTemplateOutlet']},(null as any)),
      (_l()(),i0.ɵand(0,(null as any),(null as any),0))],(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_0:any = _co.contentTemplate;
    _ck(_v,1,0,currVal_0);
  },(null as any));
}
function View_WindowComponent_3(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,(null as any),(null as any),7,'div',[['class',
      'k-content k-window-content']],[[8,'hidden',0]],(null as any),(null as any),
      (null as any),(null as any))),(_l()(),i0.ɵted((null as any),['\n            '])),
      (_l()(),i0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_WindowComponent_4)),
      i0.ɵdid(16384,(null as any),0,i2.NgIf,[i0.ViewContainerRef,i0.TemplateRef],{ngIf:[0,
          'ngIf']},(null as any)),(_l()(),i0.ɵted((null as any),['\n            '])),
      (_l()(),i0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_WindowComponent_5)),
      i0.ɵdid(16384,(null as any),0,i2.NgIf,[i0.ViewContainerRef,i0.TemplateRef],{ngIf:[0,
          'ngIf']},(null as any)),(_l()(),i0.ɵted((null as any),['\n        ']))],
      (_ck,_v) => {
        var _co:any = _v.component;
        const currVal_1:boolean = !_co.contentTemplate;
        _ck(_v,3,0,currVal_1);
        const currVal_2:any = _co.contentTemplate;
        _ck(_v,6,0,currVal_2);
      },(_ck,_v) => {
        var _co:any = _v.component;
        const currVal_0:any = ((_co.state === 'minimized') && _co.keepContent);
        _ck(_v,0,0,currVal_0);
      });
}
function View_WindowComponent_8(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,(null as any),(null as any),3,'div',[['kendoWindowDraggable',
      ''],['kendoWindowResizeHandle','']],[[2,'k-resize-handle',(null as any)]],(null as any),
      (null as any),(null as any),(null as any))),i0.ɵdid(212992,(null as any),0,i1.DraggableDirective,
      [i0.ElementRef,i0.NgZone],(null as any),(null as any)),i0.ɵdid(212992,[[2,4]],
      0,i1.ResizeHandleDirective,[i1.DraggableDirective,i0.ElementRef,i0.Renderer2,
          i1.DragResizeService],{direction:[0,'direction']},(null as any)),(_l()(),
      i0.ɵted((null as any),['\n            ']))],(_ck,_v) => {
    _ck(_v,1,0);
    const currVal_1:any = _v.context.$implicit;
    _ck(_v,2,0,currVal_1);
  },(_ck,_v) => {
    const currVal_0:any = i0.ɵnov(_v,2).hostClass;
    _ck(_v,0,0,currVal_0);
  });
}
function View_WindowComponent_7(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵted((null as any),['\n            '])),(_l()(),i0.ɵand(16777216,
      (null as any),(null as any),1,(null as any),View_WindowComponent_8)),i0.ɵdid(802816,
      (null as any),0,i2.NgForOf,[i0.ViewContainerRef,i0.TemplateRef,i0.IterableDiffers],
      {ngForOf:[0,'ngForOf']},(null as any)),(_l()(),i0.ɵted((null as any),['\n        ']))],
      (_ck,_v) => {
        var _co:any = _v.component;
        const currVal_0:any = _co.resizeDirections;
        _ck(_v,2,0,currVal_0);
      },(null as any));
}
export function View_WindowComponent_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[i0.ɵqud(671088640,1,{titleBarView:0}),i0.ɵqud(671088640,2,{resizeHandles:1}),
      (_l()(),i0.ɵted((null as any),['\n        '])),(_l()(),i0.ɵand(16777216,(null as any),
          (null as any),1,(null as any),View_WindowComponent_1)),i0.ɵdid(16384,(null as any),
          0,i2.NgIf,[i0.ViewContainerRef,i0.TemplateRef],{ngIf:[0,'ngIf']},(null as any)),
      (_l()(),i0.ɵted((null as any),['\n        '])),(_l()(),i0.ɵand(16777216,(null as any),
          (null as any),1,(null as any),View_WindowComponent_2)),i0.ɵdid(16384,(null as any),
          0,i2.NgIf,[i0.ViewContainerRef,i0.TemplateRef],{ngIf:[0,'ngIf']},(null as any)),
      (_l()(),i0.ɵted((null as any),['\n\n        '])),(_l()(),i0.ɵand(16777216,(null as any),
          (null as any),1,(null as any),View_WindowComponent_3)),i0.ɵdid(16384,(null as any),
          0,i2.NgIf,[i0.ViewContainerRef,i0.TemplateRef],{ngIf:[0,'ngIf']},(null as any)),
      (_l()(),i0.ɵted((null as any),['\n\n        '])),(_l()(),i0.ɵand(16777216,(null as any),
          (null as any),1,(null as any),View_WindowComponent_7)),i0.ɵdid(16384,(null as any),
          0,i2.NgIf,[i0.ViewContainerRef,i0.TemplateRef],{ngIf:[0,'ngIf']},(null as any)),
      (_l()(),i0.ɵted((null as any),['\n    ']))],(_ck,_v) => {
    var _co:i1.WindowComponent = _v.component;
    const currVal_0:any = _co.showDefaultTitleBar;
    _ck(_v,4,0,currVal_0);
    const currVal_1:boolean = !_co.showDefaultTitleBar;
    _ck(_v,7,0,currVal_1);
    const currVal_2:any = ((_co.state !== 'minimized') || _co.keepContent);
    _ck(_v,10,0,currVal_2);
    const currVal_3:any = _co.resizable;
    _ck(_v,13,0,currVal_3);
  },(null as any));
}
export function View_WindowComponent_Host_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,(null as any),(null as any),6,'kendo-window',
      ([] as any[]),[[1,'tabIndex',0],[2,'k-widget',(null as any)],[2,'k-window',(null as any)],
          [1,'dir',0],[2,'k-window-wrapper',(null as any)],[4,'minWidth',(null as any)],
          [4,'minHeight',(null as any)],[4,'position',(null as any)],[2,'k-window-maximized',
              (null as any)],[2,'k-state-focused',(null as any)]],[[(null as any),
          'keydown'],[(null as any),'focus'],[(null as any),'blur']],(_v,en,$event) => {
        var ad:boolean = true;
        if (('keydown' === en)) {
          const pd_0:any = ((<any>i0.ɵnov(_v,5).onComponentKeydown($event)) !== false);
          ad = (pd_0 && ad);
        }
        if (('focus' === en)) {
          const pd_1:any = ((<any>i0.ɵnov(_v,5).onComponentFocus()) !== false);
          ad = (pd_1 && ad);
        }
        if (('blur' === en)) {
          const pd_2:any = ((<any>i0.ɵnov(_v,5).onComponentBlur()) !== false);
          ad = (pd_2 && ad);
        }
        return ad;
      },View_WindowComponent_0,RenderType_WindowComponent)),i0.ɵprd(131584,(null as any),
      i1.DragResizeService,i1.DragResizeService,[i0.NgZone]),i0.ɵprd(512,(null as any),
      i1.NavigationService,i1.NavigationService,[i1.DragResizeService]),i0.ɵprd(256,
      (null as any),i3.L10N_PREFIX,'kendo.window',([] as any[])),i0.ɵprd(131584,(null as any),
      i3.LocalizationService,i3.LocalizationService,[i3.L10N_PREFIX,[2,i3.MessageService],
          [2,i3.RTL]]),i0.ɵdid(4964352,(null as any),1,i1.WindowComponent,[i0.ElementRef,
      i0.Renderer2,i1.DragResizeService,i1.NavigationService,i0.NgZone,i3.LocalizationService],
      (null as any),(null as any)),i0.ɵqud(335544320,1,{titleBarContent:0})],(_ck,
      _v) => {
    _ck(_v,5,0);
  },(_ck,_v) => {
    const currVal_0:any = i0.ɵnov(_v,5).tabIndex;
    const currVal_1:any = i0.ɵnov(_v,5).hostClasses;
    const currVal_2:any = i0.ɵnov(_v,5).hostClasses;
    const currVal_3:any = i0.ɵnov(_v,5).dir;
    const currVal_4:any = i0.ɵnov(_v,5).windowClasses;
    const currVal_5:any = i0.ɵnov(_v,5).styleMinWidth;
    const currVal_6:any = i0.ɵnov(_v,5).styleMinHeight;
    const currVal_7:any = i0.ɵnov(_v,5).stylePosition;
    const currVal_8:any = i0.ɵnov(_v,5).wrapperMaximizedClass;
    const currVal_9:any = i0.ɵnov(_v,5).wrapperFocusedClass;
    _ck(_v,0,0,currVal_0,currVal_1,currVal_2,currVal_3,currVal_4,currVal_5,currVal_6,
        currVal_7,currVal_8,currVal_9);
  });
}
export const WindowComponentNgFactory:i0.ComponentFactory<i1.WindowComponent> = i0.ɵccf('kendo-window',
    i1.WindowComponent,View_WindowComponent_Host_0,{title:'title',draggable:'draggable',
        resizable:'resizable',keepContent:'keepContent',state:'state',minWidth:'minWidth',
        minHeight:'minHeight',width:'width',height:'height',top:'top',left:'left'},
    {dragStart:'dragStart',dragEnd:'dragEnd',resizeStart:'resizeStart',resizeEnd:'resizeEnd',
        close:'close',widthChange:'widthChange',heightChange:'heightChange',topChange:'topChange',
        leftChange:'leftChange',stateChange:'stateChange'},['kendo-window-titlebar',
        '*']);
const styles_WindowTitleBarComponent:any[] = ([] as any[]);
export const RenderType_WindowTitleBarComponent:i0.RendererType2 = i0.ɵcrt({encapsulation:2,
    styles:styles_WindowTitleBarComponent,data:{}});
function View_WindowTitleBarComponent_1(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[i0.ɵncd((null as any),0),(_l()(),i0.ɵand(0,(null as any),(null as any),
      0))],(null as any),(null as any));
}
function View_WindowTitleBarComponent_3(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵted((null as any),['\n    ']))],(null as any),(null as any));
}
function View_WindowTitleBarComponent_2(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵand(16777216,(null as any),(null as any),2,(null as any),
      View_WindowTitleBarComponent_3)),i0.ɵdid(540672,(null as any),0,i2.NgTemplateOutlet,
      [i0.ViewContainerRef],{ngTemplateOutletContext:[0,'ngTemplateOutletContext'],
          ngTemplateOutlet:[1,'ngTemplateOutlet']},(null as any)),i0.ɵpod({'$implicit':0}),
      (_l()(),i0.ɵand(0,(null as any),(null as any),0))],(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_0:any = _ck(_v,2,0,_co.service);
    const currVal_1:any = _co.template;
    _ck(_v,1,0,currVal_0,currVal_1);
  },(null as any));
}
export function View_WindowTitleBarComponent_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵted((null as any),['\n    '])),(_l()(),i0.ɵand(16777216,
      (null as any),(null as any),1,(null as any),View_WindowTitleBarComponent_1)),
      i0.ɵdid(16384,(null as any),0,i2.NgIf,[i0.ViewContainerRef,i0.TemplateRef],{ngIf:[0,
          'ngIf']},(null as any)),(_l()(),i0.ɵted((null as any),['\n    '])),(_l()(),
          i0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_WindowTitleBarComponent_2)),
      i0.ɵdid(16384,(null as any),0,i2.NgIf,[i0.ViewContainerRef,i0.TemplateRef],{ngIf:[0,
          'ngIf']},(null as any)),(_l()(),i0.ɵted((null as any),['\n  ']))],(_ck,_v) => {
    var _co:i1.WindowTitleBarComponent = _v.component;
    const currVal_0:boolean = !_co.template;
    _ck(_v,2,0,currVal_0);
    const currVal_1:any = _co.template;
    _ck(_v,5,0,currVal_1);
  },(null as any));
}
export function View_WindowTitleBarComponent_Host_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,(null as any),(null as any),1,'kendo-window-titlebar',
      ([] as any[]),[[2,'k-window-titlebar',(null as any)],[2,'k-dialog-titlebar',
          (null as any)],[2,'k-header',(null as any)]],[[(null as any),'dblclick']],
      (_v,en,$event) => {
        var ad:boolean = true;
        if (('dblclick' === en)) {
          const pd_0:any = ((<any>i0.ɵnov(_v,1).handle($event)) !== false);
          ad = (pd_0 && ad);
        }
        return ad;
      },View_WindowTitleBarComponent_0,RenderType_WindowTitleBarComponent)),i0.ɵdid(245760,
      (null as any),0,i1.WindowTitleBarComponent,[i0.ElementRef,i1.DragResizeService,
          i0.NgZone],(null as any),(null as any))],(_ck,_v) => {
    _ck(_v,1,0);
  },(_ck,_v) => {
    const currVal_0:any = i0.ɵnov(_v,1).className;
    const currVal_1:any = i0.ɵnov(_v,1).className;
    const currVal_2:any = i0.ɵnov(_v,1).className;
    _ck(_v,0,0,currVal_0,currVal_1,currVal_2);
  });
}
export const WindowTitleBarComponentNgFactory:i0.ComponentFactory<i1.WindowTitleBarComponent> = i0.ɵccf('kendo-window-titlebar',
    i1.WindowTitleBarComponent,View_WindowTitleBarComponent_Host_0,{template:'template'},
    {},['*']);
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiYzovUHJvamVjdHMvWXVEUklWL1NlcnZpY2VzQVBJL1l1RHJpdi1TZXJ2aWNlc0FQSS9FbmZvcmNlbWVudC9ub2RlX21vZHVsZXMvQHByb2dyZXNzL2tlbmRvLWFuZ3VsYXItZGlhbG9nL2Rpc3QvZXMyMDE1L2luZGV4Lm5nZmFjdG9yeS50cyIsInZlcnNpb24iOjMsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIm5nOi8vL2M6L1Byb2plY3RzL1l1RFJJVi9TZXJ2aWNlc0FQSS9ZdURyaXYtU2VydmljZXNBUEkvRW5mb3JjZW1lbnQvbm9kZV9tb2R1bGVzL0Bwcm9ncmVzcy9rZW5kby1hbmd1bGFyLWRpYWxvZy9kaXN0L2VzMjAxNS9pbmRleC5kLnRzIiwibmc6Ly8vYzovUHJvamVjdHMvWXVEUklWL1NlcnZpY2VzQVBJL1l1RHJpdi1TZXJ2aWNlc0FQSS9FbmZvcmNlbWVudC9ub2RlX21vZHVsZXMvQHByb2dyZXNzL2tlbmRvLWFuZ3VsYXItZGlhbG9nL2Rpc3QvZXMyMDE1L2luZGV4LmQudHMuRGlhbG9nQ29tcG9uZW50Lmh0bWwiLCJuZzovLy9jOi9Qcm9qZWN0cy9ZdURSSVYvU2VydmljZXNBUEkvWXVEcml2LVNlcnZpY2VzQVBJL0VuZm9yY2VtZW50L25vZGVfbW9kdWxlcy9AcHJvZ3Jlc3Mva2VuZG8tYW5ndWxhci1kaWFsb2cvZGlzdC9lczIwMTUvaW5kZXguZC50cy5EaWFsb2dDb21wb25lbnRfSG9zdC5odG1sIiwibmc6Ly8vYzovUHJvamVjdHMvWXVEUklWL1NlcnZpY2VzQVBJL1l1RHJpdi1TZXJ2aWNlc0FQSS9FbmZvcmNlbWVudC9ub2RlX21vZHVsZXMvQHByb2dyZXNzL2tlbmRvLWFuZ3VsYXItZGlhbG9nL2Rpc3QvZXMyMDE1L2luZGV4LmQudHMuRGlhbG9nVGl0bGVCYXJDb21wb25lbnQuaHRtbCIsIm5nOi8vL2M6L1Byb2plY3RzL1l1RFJJVi9TZXJ2aWNlc0FQSS9ZdURyaXYtU2VydmljZXNBUEkvRW5mb3JjZW1lbnQvbm9kZV9tb2R1bGVzL0Bwcm9ncmVzcy9rZW5kby1hbmd1bGFyLWRpYWxvZy9kaXN0L2VzMjAxNS9pbmRleC5kLnRzLkRpYWxvZ1RpdGxlQmFyQ29tcG9uZW50X0hvc3QuaHRtbCIsIm5nOi8vL2M6L1Byb2plY3RzL1l1RFJJVi9TZXJ2aWNlc0FQSS9ZdURyaXYtU2VydmljZXNBUEkvRW5mb3JjZW1lbnQvbm9kZV9tb2R1bGVzL0Bwcm9ncmVzcy9rZW5kby1hbmd1bGFyLWRpYWxvZy9kaXN0L2VzMjAxNS9pbmRleC5kLnRzLkRpYWxvZ0FjdGlvbnNDb21wb25lbnQuaHRtbCIsIm5nOi8vL2M6L1Byb2plY3RzL1l1RFJJVi9TZXJ2aWNlc0FQSS9ZdURyaXYtU2VydmljZXNBUEkvRW5mb3JjZW1lbnQvbm9kZV9tb2R1bGVzL0Bwcm9ncmVzcy9rZW5kby1hbmd1bGFyLWRpYWxvZy9kaXN0L2VzMjAxNS9pbmRleC5kLnRzLkRpYWxvZ0FjdGlvbnNDb21wb25lbnRfSG9zdC5odG1sIiwibmc6Ly8vYzovUHJvamVjdHMvWXVEUklWL1NlcnZpY2VzQVBJL1l1RHJpdi1TZXJ2aWNlc0FQSS9FbmZvcmNlbWVudC9ub2RlX21vZHVsZXMvQHByb2dyZXNzL2tlbmRvLWFuZ3VsYXItZGlhbG9nL2Rpc3QvZXMyMDE1L2luZGV4LmQudHMuV2luZG93Q29tcG9uZW50Lmh0bWwiLCJuZzovLy9jOi9Qcm9qZWN0cy9ZdURSSVYvU2VydmljZXNBUEkvWXVEcml2LVNlcnZpY2VzQVBJL0VuZm9yY2VtZW50L25vZGVfbW9kdWxlcy9AcHJvZ3Jlc3Mva2VuZG8tYW5ndWxhci1kaWFsb2cvZGlzdC9lczIwMTUvaW5kZXguZC50cy5XaW5kb3dDb21wb25lbnRfSG9zdC5odG1sIiwibmc6Ly8vYzovUHJvamVjdHMvWXVEUklWL1NlcnZpY2VzQVBJL1l1RHJpdi1TZXJ2aWNlc0FQSS9FbmZvcmNlbWVudC9ub2RlX21vZHVsZXMvQHByb2dyZXNzL2tlbmRvLWFuZ3VsYXItZGlhbG9nL2Rpc3QvZXMyMDE1L2luZGV4LmQudHMuV2luZG93VGl0bGVCYXJDb21wb25lbnQuaHRtbCIsIm5nOi8vL2M6L1Byb2plY3RzL1l1RFJJVi9TZXJ2aWNlc0FQSS9ZdURyaXYtU2VydmljZXNBUEkvRW5mb3JjZW1lbnQvbm9kZV9tb2R1bGVzL0Bwcm9ncmVzcy9rZW5kby1hbmd1bGFyLWRpYWxvZy9kaXN0L2VzMjAxNS9pbmRleC5kLnRzLldpbmRvd1RpdGxlQmFyQ29tcG9uZW50X0hvc3QuaHRtbCJdLCJzb3VyY2VzQ29udGVudCI6WyIgIiwiXG4gICAgPGRpdiBjbGFzcz1cImstb3ZlcmxheVwiIEBvdmVybGF5QXBwZWFyPjwvZGl2PlxuXG4gICAgPGRpdlxuICAgICAgY2xhc3M9XCJrLXdpZGdldCBrLXdpbmRvdyBrLWRpYWxvZ1wiXG4gICAgICByb2xlPVwiZGlhbG9nXCJcbiAgICAgIFtuZ1N0eWxlXT1cInN0eWxlc1wiXG4gICAgICBAZGlhbG9nU2xpZGVJbkFwcGVhclxuICAgID5cbiAgICAgIDxrZW5kby1kaWFsb2ctdGl0bGViYXIgKm5nSWY9XCJ0aXRsZVwiIFtpZF09XCJ0aXRsZUlkXCI+e3t0aXRsZX19PC9rZW5kby1kaWFsb2ctdGl0bGViYXI+XG4gICAgICA8bmctY29udGVudCBzZWxlY3Q9XCJrZW5kby1kaWFsb2ctdGl0bGViYXJcIiAqbmdJZj1cIiF0aXRsZVwiPjwvbmctY29udGVudD5cblxuICAgICAgPGRpdiBjbGFzcz1cImstY29udGVudCBrLXdpbmRvdy1jb250ZW50IGstZGlhbG9nLWNvbnRlbnRcIj5cbiAgICAgICAgPG5nLWNvbnRlbnQgKm5nSWY9XCIhY29udGVudFRlbXBsYXRlXCI+PC9uZy1jb250ZW50PlxuICAgICAgICA8bmctdGVtcGxhdGUgW25nVGVtcGxhdGVPdXRsZXRdPVwiY29udGVudFRlbXBsYXRlXCIgKm5nSWY9XCJjb250ZW50VGVtcGxhdGVcIj48L25nLXRlbXBsYXRlPlxuICAgICAgPC9kaXY+XG5cbiAgICAgIDxuZy1jb250ZW50IHNlbGVjdD1cImtlbmRvLWRpYWxvZy1hY3Rpb25zXCIgKm5nSWY9XCIhYWN0aW9uc1wiPjwvbmctY29udGVudD5cbiAgICAgIDxrZW5kby1kaWFsb2ctYWN0aW9ucyBbYWN0aW9uc109XCJhY3Rpb25zXCIgKm5nSWY9XCJhY3Rpb25zXCI+PC9rZW5kby1kaWFsb2ctYWN0aW9ucz5cblxuICAgIDwvZGl2PlxuICAiLCI8a2VuZG8tZGlhbG9nPjwva2VuZG8tZGlhbG9nPiIsIlxuICAgIDxkaXYgY2xhc3M9XCJrLXdpbmRvdy10aXRsZSBrLWRpYWxvZy10aXRsZVwiPlxuICAgICAgPG5nLWNvbnRlbnQ+PC9uZy1jb250ZW50PlxuICAgIDwvZGl2PlxuICAgIDxkaXYgY2xhc3M9XCJrLXdpbmRvdy1hY3Rpb25zIGstZGlhbG9nLWFjdGlvbnNcIj5cbiAgICAgIDxhIGhyZWY9XCIjXCIgcm9sZT1cImJ1dHRvblwiXG4gICAgICAgICBhcmlhLWxhYmVsPVwiQ2xvc2VcIlxuICAgICAgICAgY2xhc3M9XCJrLWJ1dHRvbiBrLWJhcmUgay1idXR0b24taWNvbiBrLXdpbmRvdy1hY3Rpb24gay1kaWFsb2ctYWN0aW9uIGstZGlhbG9nLWNsb3NlXCJcbiAgICAgICAgIChjbGljayk9XCJvbkNsb3NlQ2xpY2soJGV2ZW50KVwiPlxuICAgICAgICA8c3BhbiBjbGFzcz1cImstaWNvbiBrLWkteFwiPjwvc3Bhbj5cbiAgICAgIDwvYT5cbiAgICA8L2Rpdj5cbiAgIiwiPGtlbmRvLWRpYWxvZy10aXRsZWJhcj48L2tlbmRvLWRpYWxvZy10aXRsZWJhcj4iLCJcbiAgICA8bmctY29udGVudCAqbmdJZj1cIiFhY3Rpb25zXCI+PC9uZy1jb250ZW50PlxuICAgIDxuZy1jb250YWluZXIgKm5nSWY9XCIhYWN0aW9uVGVtcGxhdGUoKVwiPlxuICAgICAgPGJ1dHRvblxuICAgICAgICBbbmdDbGFzc109XCJidXR0b25DbGFzcyhhY3Rpb24pXCJcbiAgICAgICAgKGNsaWNrKT1cIm9uQnV0dG9uQ2xpY2soYWN0aW9uLCAkZXZlbnQpXCJcbiAgICAgICAgKm5nRm9yPVwibGV0IGFjdGlvbiBvZiBhY3Rpb25zXCI+XG4gICAgICAgIHt7IGFjdGlvbi50ZXh0IH19XG4gICAgICA8L2J1dHRvbj5cbiAgICA8L25nLWNvbnRhaW5lcj5cbiAgICA8bmctdGVtcGxhdGUgW25nVGVtcGxhdGVPdXRsZXRdPVwiYWN0aW9uc1wiICpuZ0lmPVwiYWN0aW9uVGVtcGxhdGUoKVwiPjwvbmctdGVtcGxhdGU+XG4gICIsIjxrZW5kby1kaWFsb2ctYWN0aW9ucz48L2tlbmRvLWRpYWxvZy1hY3Rpb25zPiIsIlxuICAgICAgICA8a2VuZG8td2luZG93LXRpdGxlYmFyICpuZ0lmPVwic2hvd0RlZmF1bHRUaXRsZUJhclwiIFt0ZW1wbGF0ZV09XCJ0aXRsZUJhclRlbXBsYXRlXCI+XG4gICAgICAgICAgICA8ZGl2IGNsYXNzPVwiay13aW5kb3ctdGl0bGVcIj57e3RpdGxlfX08L2Rpdj5cbiAgICAgICAgICAgIDxidXR0b24ga2VuZG9XaW5kb3dNaW5pbWl6ZUFjdGlvbj48L2J1dHRvbj5cbiAgICAgICAgICAgIDxidXR0b24ga2VuZG9XaW5kb3dNYXhpbWl6ZUFjdGlvbj48L2J1dHRvbj5cbiAgICAgICAgICAgIDxidXR0b24ga2VuZG9XaW5kb3dSZXN0b3JlQWN0aW9uPjwvYnV0dG9uPlxuICAgICAgICAgICAgPGJ1dHRvbiBrZW5kb1dpbmRvd0Nsb3NlQWN0aW9uPjwvYnV0dG9uPlxuICAgICAgICA8L2tlbmRvLXdpbmRvdy10aXRsZWJhcj5cbiAgICAgICAgPG5nLWNvbnRlbnQgc2VsZWN0PVwia2VuZG8td2luZG93LXRpdGxlYmFyXCIgKm5nSWY9XCIhc2hvd0RlZmF1bHRUaXRsZUJhclwiPjwvbmctY29udGVudD5cblxuICAgICAgICA8ZGl2ICpuZ0lmPVwic3RhdGUgIT09ICdtaW5pbWl6ZWQnIHx8IGtlZXBDb250ZW50XCJcbiAgICAgICAgICAgIFtoaWRkZW5dPVwic3RhdGUgPT09ICdtaW5pbWl6ZWQnICYmIGtlZXBDb250ZW50XCJcbiAgICAgICAgICAgIGNsYXNzPVwiay1jb250ZW50IGstd2luZG93LWNvbnRlbnRcIj5cbiAgICAgICAgICAgIDxuZy1jb250ZW50ICpuZ0lmPVwiIWNvbnRlbnRUZW1wbGF0ZVwiPjwvbmctY29udGVudD5cbiAgICAgICAgICAgIDxuZy10ZW1wbGF0ZSBbbmdUZW1wbGF0ZU91dGxldF09XCJjb250ZW50VGVtcGxhdGVcIiAqbmdJZj1cImNvbnRlbnRUZW1wbGF0ZVwiPjwvbmctdGVtcGxhdGU+XG4gICAgICAgIDwvZGl2PlxuXG4gICAgICAgIDxuZy10ZW1wbGF0ZSBbbmdJZl09J3Jlc2l6YWJsZSc+XG4gICAgICAgICAgICA8ZGl2ICpuZ0Zvcj0nbGV0IGRpciBvZiByZXNpemVEaXJlY3Rpb25zJ1xuICAgICAgICAgICAgICAgIFtkaXJlY3Rpb25dPVwiZGlyXCJcbiAgICAgICAgICAgICAgICBrZW5kb1dpbmRvd1Jlc2l6ZUhhbmRsZVxuICAgICAgICAgICAgICAgIGtlbmRvV2luZG93RHJhZ2dhYmxlPlxuICAgICAgICAgICAgPC9kaXY+XG4gICAgICAgIDwvbmctdGVtcGxhdGU+XG4gICAgIiwiPGtlbmRvLXdpbmRvdz48L2tlbmRvLXdpbmRvdz4iLCJcbiAgICA8bmctY29udGVudCAqbmdJZj1cIiF0ZW1wbGF0ZVwiPjwvbmctY29udGVudD5cbiAgICA8bmctdGVtcGxhdGVcbiAgICAgIFtuZ1RlbXBsYXRlT3V0bGV0XT1cInRlbXBsYXRlXCJcbiAgICAgIFtuZ1RlbXBsYXRlT3V0bGV0Q29udGV4dF09XCJ7JyRpbXBsaWNpdCc6IHNlcnZpY2V9XCIgKm5nSWY9XCJ0ZW1wbGF0ZVwiPlxuICAgIDwvbmctdGVtcGxhdGU+XG4gICIsIjxrZW5kby13aW5kb3ctdGl0bGViYXI+PC9rZW5kby13aW5kb3ctdGl0bGViYXI+Il0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7b0JDU007TUFBQTtVQUFBO3VFQUFBLFVBQUE7TUFBQTtNQUFvRDs7SUFBZjtJQUFyQyxXQUFxQyxTQUFyQzs7O0lBQUE7SUFBQTtJQUFBO0lBQUE7SUFBQSxXQUFBLHVDQUFBO0lBQW9EO0lBQUE7Ozs7MkJBQ3BEOzs7OzJCQUdFOzs7Ozs7OztvQkFDQTtNQUFBLGdDQUFBO01BQUE7OztJQUFhO0lBQWIsV0FBYSxTQUFiOzs7OzJCQUdGOzs7O29CQUNBO01BQUE7VUFBQTt1Q0FBQSxVQUFBO01BQUE7O0lBQXNCO0lBQXRCLFdBQXNCLFNBQXRCOztJQUFBO0lBQUE7SUFBQSxXQUFBLG1CQUFBOzs7OztNQWxCTiwyQ0FDSTtVQUFBO1VBQUEsNENBQTRDO1VBQUEsZUFFNUM7VUFBQTtVQUFBLHFFQUFBO1VBQUE7VUFBQSx1Q0FLQztNQUNDO2FBQUE7VUFBQSx3QkFBcUYsNkNBQ3JGO2lCQUFBO2FBQUE7VUFBQSx3QkFBdUUsK0NBRXZFO2lCQUFBO2NBQUE7TUFBeUQsK0NBQ3ZEO1VBQUEsOERBQUE7VUFBQTtNQUFrRCwrQ0FDbEQ7VUFBQSw4REFBQTtVQUFBO01BQXdGLDZDQUNwRjtNQUVOO2FBQUE7VUFBQSx3QkFBd0UsNkNBQ3hFO2lCQUFBO2FBQUE7VUFBQSx3QkFBaUYsNkNBRTdFO2lCQUFBOztJQWRKO0lBSEYsV0FHRSxTQUhGO0lBTXlCO0lBQXZCLFdBQXVCLFNBQXZCO0lBQzJDO0lBQTNDLFlBQTJDLFNBQTNDO0lBR2M7SUFBWixZQUFZLFNBQVo7SUFDa0Q7SUFBbEQsWUFBa0QsU0FBbEQ7SUFHd0M7SUFBMUMsWUFBMEMsU0FBMUM7SUFDMEM7SUFBMUMsWUFBMEMsU0FBMUM7O0lBakJxQjtJQUF2QixXQUF1QixTQUF2QjtJQU1FO0lBSkYsV0FJRSxTQUpGOzs7O29CQ0hKO01BQUE7TUFBQTtRQUFBO1FBQUE7VUFBQTtVQUFBO1FBQUE7UUFBQTtNQUFBO3FCQUFBOzZCQUFBLDBEQUFBO01BQUE7TUFBQTs7SUFBQTs7SUFBQTtJQUFBO0lBQUE7SUFBQSxXQUFBLDZCQUFBOzs7Ozs7Ozs7OztvQkNBQSwyQ0FDSTtNQUFBO01BQUEsMERBQTJDO01BQUEsc0JBQ3pDLGtCQUF5QjtNQUNyQiwyQ0FDTjtVQUFBO1VBQUEsNENBQStDO1VBQUEsZUFDN0M7VUFBQTtVQUFBO1VBQUE7WUFBQTtZQUFBO1lBR0c7Y0FBQTtjQUFBO1lBQUE7WUFISDtVQUFBLGdDQUdrQztNQUNoQztVQUFBO01BQWtDLDZDQUNoQztNQUNBOzs7b0JDWFY7TUFBQTtVQUFBO3VFQUFBLFVBQUE7TUFBQTs7UUFBQTtRQUFBO1FBQUE7UUFBQTtRQUFBLFdBQUEsdUNBQUE7Ozs7Ozs7Ozs7MkJDQ0k7Ozs7b0JBRUU7TUFBQTtRQUFBO1FBQUE7UUFFRTtVQUFBO1VBQUE7UUFBQTtRQUZGO01BQUEsdUNBQUE7a0RBQUE7TUFHaUM7O0lBRi9CO0lBREYsV0FDRSxTQURGOztJQUdpQztJQUFBOzs7O29CQUpuQztNQUFBO01BQXdDLDZDQUN0QztVQUFBLHFFQUFBO1VBQUE7VUFBQSx1Q0FLUzs7O1FBRlA7UUFIRixXQUdFLFNBSEY7Ozs7Ozs7O29CQU9GO01BQUEsdUNBQUE7TUFBQTs7O0lBQWE7SUFBYixXQUFhLFNBQWI7Ozs7b0JBVkosMkNBQ0k7TUFBQTthQUFBO1VBQUEsd0JBQTBDLDJDQUMxQztpQkFBQTthQUFBO1VBQUEsd0JBT2UsMkNBQ2Y7aUJBQUE7YUFBQTtVQUFBLHdCQUFpRjs7SUFUckU7SUFBWixXQUFZLFNBQVo7SUFDYztJQUFkLFdBQWMsU0FBZDtJQVEwQztJQUExQyxXQUEwQyxTQUExQzs7OztvQkNWSjtNQUFBO1VBQUE7dUNBQUEsVUFBQTtNQUFBO0lBQUE7SUFBQTtJQUFBLFdBQUEsbUJBQUE7Ozs7Ozs7Ozs7b0JDQ1E7TUFBQTtVQUFBO01BQUE7UUFBQTtRQUFBO1VBQUE7VUFBQTtRQUFBO1FBQUE7TUFBQSw2RUFBQTtNQUFBO01BQUEseUNBQWlGO01BQzdFO1VBQUEsMERBQTRCO1VBQUEsVUFBZSx1Q0FDM0M7VUFBQTtjQUFBO2tCQUFBO2tCQUFBO29CQUFBO1lBQUE7WUFBQTtjQUFBO2NBQUE7WUFBQTtZQUFBO1VBQUE7VUFBQTtpQ0FBQTthQUFBO3VCQUFBO1VBQUEsZUFBMkMsdUNBQzNDO1VBQUE7Y0FBQTtjQUFBO2tCQUFBO29CQUFBO1lBQUE7WUFBQTtjQUFBO2NBQUE7WUFBQTtZQUFBO1VBQUE7VUFBQTtpQ0FBQTthQUFBO3VCQUFBO1VBQUEsZUFBMkMsdUNBQzNDO1VBQUE7Y0FBQTtjQUFBO2tCQUFBO29CQUFBO1lBQUE7WUFBQTtjQUFBO2NBQUE7WUFBQTtZQUFBO1VBQUE7VUFBQTtpQ0FBQTthQUFBO3VCQUFBO1VBQUEsZUFBMEMsdUNBQzFDO1VBQUE7Y0FBQTtjQUFBO2tCQUFBO1lBQUE7WUFBQTtjQUFBO2NBQUE7WUFBQTtZQUFBO1VBQUE7VUFBQTtpQ0FBQTthQUFBO3VCQUFBO1VBQUEsZUFBd0M7O0lBTE87SUFBbkQsV0FBbUQsU0FBbkQ7OztJQUFBO0lBQUE7SUFBQTtJQUFBLFdBQUEsNkJBQUE7SUFDZ0M7SUFBQTtJQUM1QjtJQUFBO0lBQUE7SUFBQTtJQUFBO0lBQUE7SUFBQTtJQUFBLFdBQUEsdUVBQUE7SUFDQTtJQUFBO0lBQUE7SUFBQTtJQUFBO0lBQUE7SUFBQTtJQUFBLFlBQUE7UUFBQSxVQUFBO0lBQ0E7SUFBQTtJQUFBO0lBQUE7SUFBQTtJQUFBO0lBQUE7SUFBQSxZQUFBO1FBQUEsVUFBQTtJQUNBO0lBQUE7SUFBQTtJQUFBO0lBQUE7SUFBQTtJQUFBLFlBQUEsaUVBQUE7Ozs7MkJBRUo7Ozs7MkJBS0k7Ozs7Ozs7O29CQUNBO01BQUEsZ0NBQUE7TUFBQTs7O0lBQWE7SUFBYixXQUFhLFNBQWI7Ozs7b0JBSko7TUFBQTtNQUFBLDhCQUV1QztNQUNuQzthQUFBO1VBQUEsd0JBQWtEO01BQ2xEO2FBQUE7VUFBQSx3QkFBd0Y7OztRQUQ1RTtRQUFaLFdBQVksU0FBWjtRQUNrRDtRQUFsRCxXQUFrRCxTQUFsRDs7O1FBSEE7UUFESixXQUNJLFNBREo7Ozs7b0JBUUk7TUFBQTtNQUFBLG1EQUFBO01BQUEsOERBQUE7TUFBQTs4QkFBQSw2Q0FHeUI7YUFBQTtJQUh6QjtJQUNJO0lBREosV0FDSSxTQURKOztJQUFBO0lBQUEsV0FBQSxTQUFBOzs7O29CQUQ0QixtREFDNUI7TUFBQSw0RUFBQTtNQUFBO01BQUEsdUNBSU07OztRQUpEO1FBQUwsV0FBSyxTQUFMOzs7OztNQWxCWiwrQ0FDUTtVQUFBLDhEQUFBO1VBQUE7TUFNd0IsK0NBQ3hCO1VBQUEsOERBQUE7VUFBQTtNQUFxRixpREFFckY7VUFBQSw4REFBQTtVQUFBO01BS00saURBRU47VUFBQSw4REFBQTtVQUFBO01BTWM7O0lBdEJTO0lBQXZCLFdBQXVCLFNBQXZCO0lBTzJDO0lBQTNDLFdBQTJDLFNBQTNDO0lBRUs7SUFBTCxZQUFLLFNBQUw7SUFPYTtJQUFiLFlBQWEsU0FBYjs7OztvQkNqQlI7TUFBQTtVQUFBO1VBQUE7Y0FBQTtVQUFBO1FBQUE7UUFBQTtVQUFBO1VBQUE7UUFBQTtRQUFBO1VBQUE7VUFBQTtRQUFBO1FBQUE7VUFBQTtVQUFBO1FBQUE7UUFBQTtNQUFBO2dEQUFBO2dEQUFBO01BQUE7b0RBQUE7VUFBQSxvQkFBQTs2RkFBQTtNQUFBOztJQUFBOztJQUFBO0lBQUE7SUFBQTtJQUFBO0lBQUE7SUFBQTtJQUFBO0lBQUE7SUFBQTtJQUFBO0lBQUEsV0FBQTtRQUFBLDZCQUFBOzs7Ozs7Ozs7Ozs7Ozs7MkJDQ0k7Ozs7b0JBR3NFOzs7b0JBRnRFO01BQUEsd0NBQUE7TUFBQTtVQUFBLCtEQUVFOzs7SUFBQTtJQURBO0lBREYsV0FFRSxVQURBLFNBREY7Ozs7b0JBRkosMkNBQ0k7TUFBQTthQUFBO1VBQUEsd0JBQTJDLDJDQUMzQztpQkFBQTthQUFBO1VBQUEsd0JBR2M7O0lBSkY7SUFBWixXQUFZLFNBQVo7SUFHcUQ7SUFGckQsV0FFcUQsU0FGckQ7Ozs7b0JDRko7TUFBQTtVQUFBO01BQUE7UUFBQTtRQUFBO1VBQUE7VUFBQTtRQUFBO1FBQUE7TUFBQSw2RUFBQTtNQUFBO21CQUFBO0lBQUE7O0lBQUE7SUFBQTtJQUFBO0lBQUEsV0FBQSw2QkFBQTs7Ozs7In0=



// WEBPACK FOOTER //
// c:/Projects/YuDRIV/ServicesAPI/YuDriv-ServicesAPI/Enforcement/src/$$_gendir/~/@progress/kendo-angular-dialog/dist/es2015/index.ngfactory.ts